import Button from '@/components/Button';
import WorkflowLogsModalDetails from '@/components/modals/workflowLogsModal/WorkflowLogsModalDetails';
import WorkflowLogsModalListing from '@/components/modals/workflowLogsModal/WorkflowLogsModalListing';
import WorkflowLogsModalStateHandler from '@/components/modals/workflowLogsModal/WorkflowLogsModalStateHandler';
import ModalV2 from '@/components/ModalV2';
import { FiX } from '@/components/react-icons/main/index.esm';
import setQuery from '@/lib/setQuery';
import { setModalState } from '@/redux/actions/uiActions/modalActions';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import memoizeSelector from '@/redux/lib/memoizeSelector';
import selectors from '@/redux/selectors/selectors';
import { modal } from '@/redux/selectors/uiSelectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const WorkflowLogsModal = () => {
  const modalState = useSelector(memoizeSelector('modal:workflowLogs', (state) => modal(state, 'workflowLogs')));
  const show = modalState?.open;
  const isLogsModalOpen = useArgSelector(selectors.query, 'logs');

  const handleClose = () => {
    setModalState('workflowLogs', { open: false });
    setQuery({ logs: null, workflowId: null, search: null, logId: null, logTab: null, detailsSearch: null, logStepId: null, time: null, scrollTo: null, workflowVersion: null });
  };

  useEffect(() => {
    if (isLogsModalOpen === 'true') {
      setModalState('workflowLogs', { open: true });
    }
  }, []);

  return (
    <ModalV2 show={show} className="workflow-logs-modal" onHide={handleClose} isFullScreen centered noHeader noFooter>
      <Button className="ghost close-button negative-right" icon={FiX} onClick={handleClose} title={'Close'} />
      <div className="workflow-logs-modal-content">
        <WorkflowLogsModalListing />
        <WorkflowLogsModalDetails />
      </div>
      <WorkflowLogsModalStateHandler />
    </ModalV2>
  );
};

export default WorkflowLogsModal;
